export default __webpack_public_path__ + "static/O0131-1124add91dfbf7532c7b57e39b2de27a.png";